import { Link as LinkLi } from '@material-ui/core';
import Box from '@material-ui/core/Box';
import { pageUrls } from 'globalconfig/constants/keys';
import { mediaUrls } from 'globalconfig/constants/mediaUrls';
import PropTypes from 'prop-types';
import React, { lazy, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { columns } from './config';
import ViewMoreText from 'globalcomponents/ViewMoreText';

const layout = window?.$environment?.CURRENT_LAYOUT;
const Breadcrumb = lazy(() => import(`globalcomponents/Breadcrumb`));
const Table = lazy(() => import(`globalcomponents/UI/Table/${layout}`));
const Button = lazy(() => import(`globalcomponents/UI/Button/${layout}`));
const Icon = lazy(() => import(`globalcomponents/UI/Icon/${layout}`));
const Modal = lazy(() => import(`globalcomponents/UI/Modal/${layout}`));
const SvgIcon = lazy(() => import(`globalcomponents/SvgIcon/${layout}`));

const Index = ({ theme, filters, ...contentProps }) => {
  return (
    <Box style={{ ...theme.palette.contentStyle }}>
      <Breadcrumb filters={filters} />
      <Component {...contentProps} />
    </Box>
  );
};
export default Index;

const Component = ({ callback, history, Styled, deleteCustomDvir, i18n, customDvir, enableCustomDvir }) => {
  const [ModalListObject, setModalListObject] = useState({
    header: '',
    content: () => {},
  });

  const [open, setOpen] = useState(false);

  const closeModal = () => {
    setOpen(false);
  };

  const clickedModal = () => {
    setOpen(true);
  };

  const generateRows = () => {
    const updatedList = customDvir.data.map((item) => {
      item.formName = <ViewMoreText text={item.formName} maxChars={80} />;
      item.assetCount = <ViewMoreText text={item.assetCount} maxChars={80} />;
      item.unitType = <ViewMoreText text={item.unitType} maxChars={80} />;
      return item;
    });
    
    return updatedList;
  };

  const addVehicle = () => {
    let dv = document.getElementById('addUsers');
    if (dv.style.display === 'block') {
      dv.style.display = 'none';
    } else {
      dv.style.display = 'block';
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const popup = document.getElementById('addUsers');
      const trigger = document.getElementById('addVehiclesTarget');

      if (popup && !popup.contains(event.target) && trigger && !trigger.contains(event.target)) {
        popup.style.display = 'none';
      }
    };

    document.addEventListener('click', handleClickOutside);

    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const confirmAction = (titleKey, btnLabel, onConfirm) => {
    setModalListObject({
      content: () => (
        <Styled.ModalWrapper>
          <div className="imageSection">
            <SvgIcon value={mediaUrls.confirmIcon} alt="Are you sure" className="popup-svg" />
          </div>
          <h2 style={{ textAlign: 'center' }}>{i18n.t(titleKey)}</h2>
          <div className="deletePopupBtn">
            <div className="cancelBtn">
              <Button label={i18n.t('common.cancel')} type="reset" onClick={closeModal} />
            </div>
            <div className="deletebtn">
              <Button
                label={btnLabel}
                onClick={() => {
                  onConfirm();
                  closeModal();
                }}
              />
            </div>
          </div>
        </Styled.ModalWrapper>
      ),
    });
    clickedModal();
  };

  return (
    <Styled.Wrapper>
      <Styled.LinkWrapper>
        <div style={{ position: 'relative' }}>
          <Icon
            className="addNewForm"
            src={mediaUrls?.addVehicle}
            primary
            onClick={() => addVehicle()}
            tooltip={i18n.t('common.add')}
            id="addVehiclesTarget"
          />
          <div id="addUsers" className="vehicleModal">
            <ul>
              <li>
                <LinkLi
                  component={Link}
                  variant="body2"
                  to={`${pageUrls.customDvirEnabled}/add`}
                  onClick={() => {
                    closeModal();
                  }}
                >
                  {i18n.t('common.vehicle')}
                </LinkLi>
              </li>
              <li>
                <LinkLi
                  component={Link}
                  variant="body2"
                  to={`${pageUrls.customDvirEnabled}/addTrailer`}
                  onClick={() => {
                    closeModal();
                  }}
                >
                  {i18n.t('common.trailer')}
                </LinkLi>
              </li>
            </ul>
          </div>
        </div>
      </Styled.LinkWrapper>

      <Table
        type="client"
        defaultSortBy={{ sortBy: 'formName', order: 'desc' }}
        title=""
        columns={columns}
        data={generateRows()}
        emptyMessage={'common.tableEmptyMessage'}
        itemsPerPage={15}
        actions={[
          {
            icon: (row) => (
              <Icon
                src={mediaUrls?.edit}
                onClick={() =>
                  history.push(`${pageUrls.customDvirEnabled}/${row.unitType === 'TRAILER' ? 'editTrailer' : 'edit'}/${row.id}`)
                }
              />
            ),
          },
          {
            icon: (row) => (
              <Icon
                src={mediaUrls?.deleteIcon}
                onClick={() =>
                  confirmAction('common.sureConfirm', i18n.t('common.deletePopup'), () =>
                    deleteCustomDvir({ apiId: 'deleteCustomDvir', data: { id: row.id }, callback })
                  )
                }
              />
            ),
          },
          {
            icon: (row) => (
              <Icon
                src={row.isEnabled ? mediaUrls?.toggleOn : mediaUrls?.toggleOff}
                onClick={() =>
                  confirmAction('common.sureConfirm', i18n.t(row.isEnabled ? 'common.disablePopup' : 'common.enablePopup'), () =>
                    enableCustomDvir({
                      apiId: 'enableCustomDvir',
                      data: { id: row.id, isEnable: !row.isEnabled },
                      callback,
                    })
                  )
                }
              />
            ),
          },
        ]}
        i18n={i18n}
      />
      <Modal open={open} setOpen={setOpen} data={ModalListObject} />
    </Styled.Wrapper>
  );
};

Component.propTypes = {
  history: PropTypes.object.isRequired,
  callback: PropTypes.func.isRequired,
};
